const PERMISSION_KEY= "company:stock_analysis_report";
const PAGE_URL = {
    STOCK_ANALYSIS_REPORT_PAGE: "/admin/company/stock-analysis-report"
}

export {PERMISSION_KEY, PAGE_URL}

